import type { IconData } from '@stacksjs/iconify-core'

export const mobilePhone: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M23.62 6.09h1.52v24.38h-1.52ZM8.38 30.47h15.24V32H8.38Zm12.19-9.14h1.53v1.52h-1.53Zm0-3.05h1.53v1.52h-1.53Zm-1.52 9.14h3.05v1.53h-3.05Zm0-3.04h3.05v1.52h-3.05ZM9.91 7.61v9.15H22.1V7.61Zm7.62 3.05H16v1.53h-1.52v1.52h-1.53v1.52h-1.52V9.14h6.1Zm1.52 9.14h-1.52v-1.52h-3.05v1.52h-1.53v1.53h1.53v1.52h3.05v-1.52h1.52zm-4.57 7.62h3.05v1.53h-3.05Zm0-3.04h3.05v1.52h-3.05Zm-4.57 3.04h3.04v1.53H9.91Zm0-3.04h3.04v1.52H9.91Zm0-3.05h1.52v1.52H9.91Zm0-3.05h1.52v1.52H9.91ZM8.38 0h1.53v1.52H8.38Z\"/><path fill=\"currentColor\" d=\"M8.38 6.09h15.24V4.57H11.43V1.52H9.91v3.05H8.38V1.52H6.86v28.95h1.52z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default mobilePhone
